import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=1cd5d0a6&scoped=true&"
import script from "./CardIcon.vue?vue&type=script&lang=ts&"
export * from "./CardIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CardIcon.vue?vue&type=style&index=0&id=1cd5d0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5d0a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
installComponents(component, {GFaIcon})
